/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Accordion, AccordionRow } from '@paypalcorp/pp-react';
import RenderEcmRichText from '../Text/RenderEcmRichText';
import styles from './AccordionWrapper.module.less';
import { trackButtonClick } from '../../lib/fpti';

interface AccordionDataItem<T extends React.ElementType = 'p'> {
  heading: string;
  label: string;
  key: string;
  name: string;
  content: string;
  as?: T;
}
type AccordionWrapperProps<T extends React.ElementType = 'p'> = {
  key: string;
  name?: string;
  accordionData: AccordionDataItem<T>[];
};

export const AccordionWrapper: React.FC<AccordionWrapperProps | any> = ({ ecmContent }) => {
  const { accordionData } = ecmContent;

  return (
    <Accordion name="myAccordion" headerSize="large" className={styles.accordian_container}>
      {accordionData &&
        accordionData.map((item: AccordionDataItem, index: number) => {
          const { label, content } = item;
          return (
            <AccordionRow
              key={index}
              heading={label}
              headerClassName={styles.accordian_row_header}
              onClick={() => trackButtonClick('Accordion', null, label)}
            >
              {' '}
              <RenderEcmRichText content={content} />
            </AccordionRow>
          );
        })}
    </Accordion>
  );
};
